<template>
  
    <div class="bg-blue-200 h-full w-full mb-32 lg:mt-40">
  
  
  
          <div class="h-full w-full">
  
              <transition name="fade" appear class="bg-pink-400 h-1/2 w-full">
                  <div class="h-full w-full flex justify-center items-center">
        
                                              
                      <div class="flex flex-row justify-between items-center h-screen w-full">
  
                          <locations-map :slots="modalSlots" :onePitchSlot="onePitchSlot" :showOnlyTheOnePitch="showOnlyTheOnePitch"
                          :dayDate="dayDate" :setHighlighted="setHighlighted"
                          :refreshedMap="refreshedMap"/>
                      </div>
                  </div>
              </transition>
          </div>
  
  
          <div v-if="highLightedSlotList.length > 0" class="mt-10 w-full mb-20 lg:mb-20">
              
              <div class="mySessionsDivider" :key="dayDate">
                          
                  <div class="myCardDiv" ref="slotRef" v-for="(oneSlot, index) in highLightedSlotList" :key="index">
  
                      <pitch-card :key="dayDate"
                      :email="email" :myReload="myReload" :isCard="true" :displayModal="displayModal"
                      :mySlot="oneSlot" :index="index" :dayDate="dayDate" :showPitchPage="showPitchPage" 
                      :showDescription="showDescription" :searchStartTime="searchStartTime" :searchEndTime="searchEndTime"
                      :addBookingTime="addBookingTime" :removeBookingTime="removeBookingTime" :disableButton="disableButton"
                      :openOnePitchMapModal="openOnePitchMapModal"/>
                  </div>
              </div>
  
              <div class="h-32">
              </div>
          </div>
    </div>
  
  </template>
  
  <script>
  import Vue from 'vue';
  
  // import LocationsMap from './LocationsPitchSessionsMap';
  import LocationsMap from './PitchLocationsMap';
  
  import pitchCard from './PitchCard';
  
  export default {
  
      mounted(){
  
          // console.log(`player: ${JSON.stringify(this.  player)}`)
      },
  
      props:{
  
          refreshedMap: 0,
  
          showOnlyTheOnePitch: false,
  
          onePitchSlot: {
  
              type: Object
          },
  
          tokenId: 0,
  
          showDescription:{
  
              type: Function
          },
  
          disableButton: false,
  
          openOnePitchMapModal:{
  
              type: Function
          },
  
          myReload: {
  
              type: Function
          },
  
  
           displayModal: {
  
              type: Function
          },
  
          player: {
  
              type: Object,
          },
  
          addBookingTime: {
  
              type: Function
          },
  
          removeBookingTime: {
  
              type: Function
          },
  
          searchStartTime: '',
  
          searchEndTime: '',
  
          email: '',
  
          isCard: false,
  
          userId: 0,
  
          dayDate: '',
  
          book: {
              
              type: Function
          },
  
          cancelBooking: {
  
              type: Function
          },
  
          changeShowModal:{
  
              type: Function
          },
  
  
          showPitchPage: {
  
              type: Function
          },
  
          modalSlots: {
              type: Array 
          },
  
          showModal: false,
      },
  
      components: {
  
          LocationsMap,
          
          pitchCard
      },
  
      methods:{
  
  
          setHighlighted(slot, index){
  
              // console.log(`modalSlots: ${JSON.stringify(this.modalSlots[0].two_pitch.location.id)}`);
              // console.log(`slot: ${JSON.stringify(slot.two_pitch.location.id)}`);
  
              // console.log(`slot: ${JSON.stringify(slot.two_pitch.location)}`);
  
              // console.log(`modalSlots: ${JSON.stringify(this.modalSlots)}`);
              this.highLightedSlot = slot;
              this.highLightedSlotList  = this.modalSlots.filter(item => item.two_pitch.location.id == slot.two_pitch.location.id)
  
          },
  
  
      },
  
      data: function(){
  
          return{
  
              displayingImage: '',
  
              highLightedSlot: null,
              highLightedSlotList: [],
  
              index: 0,
          }
      }
  }
  </script>
  
  <style>
  
  @media screen and (max-width: 768px) {
  
      .modal-overlay {
  
          position: absolute;
  
          top: 25%;
  
      }
  }
  
  @media screen and (min-width: 768px) {
  
      .modal-overlay {
  
          position: absolute;
  
  /* transform: translate(50%, 50%); */
  
          top: 25%;
          left: 25%;
      }
  
  }
  </style>